module.exports = __webpack_public_path__ + "static/media/example2.23ad664e.gif";